import {
    Col,
    Row,
    Modal,
    Form,
    Input,
    Select,
    Switch,
    TimePicker,
    InputNumber,
    Tag,
    Spin,
    Popconfirm,
} from "antd";
import { React, useEffect, useState } from "react";
import ButtonComp from "../ButtonComp/ButtonComp";
import CustomTable from "../Table/CustomTable";
import "./PlantSettingsAlert.css";
import { CheckCircleOutlined, edit, trash } from "../../Utils/imports";
import { PlantSettingsAlertsVar } from "../../Utils/variables";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";


import { createAlert, deleteAlert, editAlert } from "../../API-Interaction/apiServices/plantSettings.api";
import { antIcon } from "../../Helpers/helpers";


const { TextArea } = Input;
const {
    heading,
    type,
    lines,
    status,
    sms_alert,
    select_time,
    from_value,
    to_value,
    email_address,
    subject,
    content,
    email_cc,
    email_bcc,
} = PlantSettingsAlertsVar;

const PlantSettingsAlert = () => {
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    let lineField = useSelector(state => state?.plant?.current?.plant?.productionLines);
    let { current } = useSelector(state => state?.plant);
    const [modalHeading, setModalHeading] = useState('Add Alert');
    const { pageLoaders, componentLoaders } = useSelector(state => state.utils.loaders)
    let lineOps = lineField?.map((item, index) => (
        { value: item.id, label: item.lineName, key: index }
    ))
    const typeOps = [
        { value: "efficiency", label: "Efficiency" },
        { value: "lineSettingsUpdate", label: "Changes in Line Settings" },
        { value: "Speed_Set_Point", label: "Speed Set Point" },
        { value: "perform_yeild", label: "Perform Yeild" },
        { value: "Average_Brix", label: "Average Brix" },
        { value: "downtime", label: "Downtime" },
    ]
    let { alertSettings = null } = useSelector(state => state?.plant?.current?.plant)
    const [alertModal, setAlertModal] = useState(false);
    const [doWhat, setDoWhat] = useState('create');
    const [switches, setSwitches] = useState({ status: false, medium: false });
    let options = [];

    const handleChange = (...params) => {
        let [two] = params
        console.log(`${two}`);
    };
    const validateEmail = (email) => {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    const onEmailChange = (x) => {
        let newElem = x[x.length - 1]
        let toEmails = options
        if (toEmails.length > x.length || validateEmail(newElem))
            toEmails = x
        options = toEmails
    }
    const onFinish = async (values) => {
        if (doWhat === 'edit')
            await editAlert(dispatch, { values, lineOps, rec: switches?.prevRec }, current)
        if (doWhat !== 'edit')
            await createAlert(dispatch, { ...values, lineOps }, current)
        setSwitches({ status: false, medium: false, prevRec: null })
        setDoWhat('create')
        setAlertModal(false)
    };

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    const handleEdit = (record) => {
        console.log({ record, lines: record?.lines?.map((line) => ({ label: line.lineName, value: line?.id })) })
        setModalHeading('Edit Alert');
        setDoWhat('edit')
        form.setFieldsValue({
            type: typeOps.filter(type => type.value == record.type)[0],
            subject: record?.subject,
            content: record?.content,
            lines: record?.lines?.map((line, index) => ({ label: line.lineName, value: line?.id, key: index })),
            emailAddress: record.email || [],
            bccEmail: record.emailBCC || [],
            ccEmail: record.emailCC || [],
            fromValue: record.fromValue,
            toValue: record.toValue,
            time: moment(record.time)
        })
        setSwitches({
            status: record?.status == 'active' ? true : false,
            medium: record?.medium == 'sms' ? false : true,
            prevRec: record
        })
        setAlertModal(true)
    }

    const handleDelete = async (record) => {
        console.log(record)
        await deleteAlert(dispatch, { lineOps, rec: record }, current)
    }

    const AlertModal = () => {

        return (
            <Modal
                title={<h2>{modalHeading}</h2>}
                centered
                open={alertModal}
                onCancel={() => setAlertModal(false)}
                maskClosable={false}
                footer={null}
                className="AlertModal"
            >
                <Spin indicator={antIcon} spinning={componentLoaders?.alertModal || false} >
                    <Form
                        form={form}
                        name="plantRoleForm"
                        className="plantRoleForm"
                        labelCol={{
                            span: 8,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        initialValues={{
                            remember: false,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <h4>{type}</h4>
                        <Form.Item
                            name="type"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select the type!",
                                },
                            ]}
                        >
                            <Select
                                className="width100P"
                                options={typeOps}
                                allowClear
                            />
                        </Form.Item>

                        <h4>{lines}</h4>
                        <Form.Item
                            name="lines"
                            rules={[
                                {
                                    required: true,
                                    message: "Please select line!",
                                },
                            ]}
                        >
                            <Select
                                options={lineOps}
                                mode="tags"
                                style={{ width: '100%' }}
                                tokenSeparators={[',']}>
                            </Select>
                        </Form.Item>

                        <Row className="dflex alignCenter">
                            <Col span={12}>
                                <h4>{status}</h4>
                                <Form.Item
                                    name="status"
                                >
                                    <Switch defaultChecked={switches.status || false} unCheckedChildren="InActive" checkedChildren="Active" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <h4>{sms_alert}</h4>
                                <Form.Item
                                    name="medium">
                                    <Switch defaultChecked={switches.medium || false} unCheckedChildren="SMS" checkedChildren="Email" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <h4>{select_time}</h4>
                                <Form.Item
                                    name="time"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select time!",
                                        },
                                    ]}
                                >
                                    <TimePicker format={'HH:mm'} className="width100P boxBorderRad" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={6}>
                            <Col span={12}>
                                <h4>{from_value}</h4>
                                <Form.Item
                                    name='fromValue'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter from value!",
                                        },
                                    ]}
                                >
                                    <InputNumber className="width100P boxBorderRad" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <h4>{to_value}</h4>
                                <Form.Item
                                    name='toValue'
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter to value!",
                                        },
                                    ]}
                                >
                                    <InputNumber className="width100P boxBorderRad" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <h4>{email_address}</h4>
                        <Form.Item
                            name="emailAddress"
                            rules={[
                                // {
                                //   type: "email",
                                //   message: "Invalid Email",
                                // },
                                {
                                  required: true,
                                  message: "Please input your email!",
                                },
                              ]}
                        >
                            <Select
                                mode="tags"
                                value={options}
                                style={{ width: '100%' }}
                                tokenSeparators={[',']}>
                            </Select>
                        </Form.Item>

                        <label style={{fontSize: "16px"}}>{subject}</label>
                        <Form.Item
                            name="subject"
                            rules={[
                                {
                                    required: false,
                                    message: "Please Enter Subject!",
                                },
                            ]}
                        >
                            <Input className="width100P boxBorderRad" placeholder={"Add Subject"} />
                        </Form.Item>

                        <label style={{fontSize: "16px"}}>{content}</label>
                        <Form.Item
                            name="content"
                            rules={[
                                {
                                    required: false,
                                    message: "Please valid content!",
                                },
                            ]}
                        >
                            <TextArea className="boxBorderRad" rows={4} />
                        </Form.Item>

                        <label style={{fontSize: "16px"}}>{email_cc}</label>
                        <Form.Item
                            name="ccEmail"
                            rules={[
                                // {
                                //     type: "email",
                                //     message: "Invalid Email",
                                // },
                                {
                                    required: false,
                                    message: "Please Enter CC:Email!",
                                },
                            ]}
                        >
                            <Select
                            mode="tags"
                                className="width100P boxBorderRad"
                                onChange={handleChange}
                                options={options}
                                tokenSeparators={[',']}
                            />
                        </Form.Item>

                        <label style={{fontSize: "16px"}}>{email_bcc}</label>
                        <Form.Item
                            name="bccEmail"
                            rules={[
                                // {
                                //     type: "email",
                                //     message: "Invalid Email",
                                // },
                                {
                                    required: false,
                                    message: "Please Enter BCC:Email!",
                                },
                            ]}
                        >
                            <Select
                                mode="tags"
                                className="width100P boxBorderRad"
                                onChange={handleChange}
                                options={options}
                                tokenSeparators={[',']}
                            />
                        </Form.Item>

                        <Form.Item className="width100P dflex alignCenter justifyFE">
                            <ButtonComp
                                htmlType="submit"
                                theme="blue"
                                icon={<CheckCircleOutlined />}
                                text="Save"
                            />
                        </Form.Item>
                    </Form>
                </Spin>
            </Modal >
        );
    };

    const PlantAlertTableColumns = [
        {
            title: "Condition",
            dataIndex: "condition",

            render: (text, record) => {
                if (!record.type || record.type === 'downtime') return <span>Down for {record.duration}+ minutes</span>;
                if (record.type === 'lineSettingsUpdate') return <span>Changes in line settings</span>;
                if (record.type === 'stop-shift') return <span>Production Line Shift Stopped</span>;
                if (record.type === 'add-rejection') return <span>Rejection above {record.value} added</span>;
                if (record.type === 'rework') return <span>Rework above {record.value} added</span>;
                if (record.type === 'oee') return <span>OEE in range ({record.oeeFrom} - {record.oeeTo})% for {record.duration}+ minutes</span>;
                if (record.type === 'availability') return <span>Availability above {record.value}% for {record.duration}+ minutes</span>;
                if (record.type === 'performance') return <span>Performance above {record.value}% for {record.duration}+ minutes</span>;
                if (record.type === 'quality') return <span>Quality above {record.value}% for {record.duration}+ minutes</span>;
                if (record.type === 'totalRejections') return <span>Total Rejections above {record.value} for {record.duration}+ minutes</span>;
                return <span style={{ textTransform: 'capitalize' }}>{record.type}</span>;
            },
        },
        {
            title: "Email Address",
            dataIndex: "emailaddress",
            render: (text, record) => (
                <>
                {record?.email?.join(', ')}
                    {record?.emailCC && record?.emailCC?.length && (
                        <div>CC: {record.emailCC.join(', ')}</div>
                    )}
                    {record?.emailBCC && record?.emailBCC?.length && (
                        <div>BCC: {record?.emailBCC.join(', ')}</div>
                    )}
                </>
            )
        },
        {
            title: 'Line',
            dataIndex: 'line',
            render: (text, record) => (
                <>
                    {record?.lines?.map(line => <Tag key={line.id} style={{ marginTop: 5 }}>{line.lineName}</Tag>)}
                </>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (text, record) => (
                <>
                    <Switch
                        checked={record.status === 'active' ? true : false}
                        checkedChildren='Active'
                        unCheckedChildren='InActive'
                    />
                    {
                        record.inactiveTill &&
                        moment(record.inactiveTill) > moment().valueOf() &&
                        <Tag style={{ marginTop: 5 }}>Active In: {moment(record.inactiveTill).toNow(true)}</Tag>
                    }
                </>)
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            render: (key, rec) => <div className='dflex alignCenter justify gap10'><img onClick={() => handleEdit(rec)} src={edit} className="cursorPointer" />
            <Popconfirm placement="topRight" okText="Delete" cancelText="Cancel" okButtonProps={{className: "popRed"}} cancelButtonProps={{className: "popBlue"}} title="Confirm delete ?" onConfirm={() => { handleDelete(rec) }}>
            <img src={trash} className="cursorPointer" />
            </Popconfirm>
            </div>,
            align: "center"
        },
    ]

    return (
        <Row className="pt1">
            <Row className="width100P">
                <Col span={12}>
                    <h1 className="pageHead">{heading}</h1>
                </Col>
                <Col span={12} className="dflex justifyFE">
                    <ButtonComp
                        onClick={() => { form.resetFields(); setAlertModal(true); }}
                        theme="blue"
                        text="Add Alert"
                        img={"notification-bing"}
                    />{" "}
                    <AlertModal />
                </Col>
            </Row>
            <Row className="width100P pt10 ">
                <Col span={24}>
                    <CustomTable
                        columns={PlantAlertTableColumns}
                        dataSource={alertSettings}
                    />
                </Col>
            </Row>
        </Row>
    );
};

export default PlantSettingsAlert;
